var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("p", { staticClass: "poll-title poll-title--centered" }, [
      _vm._v(_vm._s(_vm._("Скільки місяців вашому малюку?")))
    ]),
    _vm._m(0),
    _c(
      "div",
      { staticClass: "range-wrap" },
      [
        _c("range-slider", {
          attrs: {
            marks: _vm.marks,
            height: 15,
            min: 5,
            max: 13,
            tooltip: "none"
          },
          scopedSlots: _vm._u([
            {
              key: "process",
              fn: function(ref) {
                var start = ref.start
                var end = ref.end
                var style = ref.style
                var index = ref.index
                return [
                  _c("div", {
                    staticClass: "vue-slider-process custom-process",
                    style: [style]
                  })
                ]
              }
            },
            {
              key: "dot",
              fn: function() {
                return [_c("div", { staticClass: "custom-dot" })]
              },
              proxy: true
            },
            {
              key: "mark",
              fn: function(ref) {
                var pos = ref.pos
                var current = ref.value
                var label = ref.label
                return [
                  _c(
                    "div",
                    {
                      staticClass: "custom-mark",
                      class: { "is-active": _vm.value == current },
                      style: { left: pos - 5 + "%" }
                    },
                    [
                      _c("p", { staticClass: "custom-mark__title" }, [
                        _vm._v(_vm._s(label))
                      ]),
                      _c("p", { staticClass: "custom-mark__text" }, [
                        _vm._v(_vm._s(_vm._("місяців")))
                      ])
                    ]
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.value,
            callback: function($$v) {
              _vm.value = $$v
            },
            expression: "value"
          }
        })
      ],
      1
    ),
    _c(
      "button",
      {
        staticClass: "poll-btn",
        attrs: { href: "" },
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.next($event)
          }
        }
      },
      [_vm._v(_vm._s(_vm._("Далі")) + "  ")]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "poll-child-decor" }, [
      _c("img", {
        staticClass: "poll-child-decor__img",
        attrs: { src: "/static/images/poll-child.svg" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b83f71a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b83f71a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/shared/components/poll/steps/age.vue
// module id = 214
// module chunks = 4